import type { ToastItem } from "src/hooks/useToast";

interface Props {
  toasts: ToastItem[];
  onDismiss: (id: number) => void;
}

export function Toast({ toasts, onDismiss }: Props) {
  if (toasts.length === 0) return null;

  return (
    <div className="toast-stack" role="alert" aria-live="assertive">
      {toasts.map((t) => (
        <div key={t.id} className={`toast-item toast-item--${t.variant}`}>
          <span className="toast-message">{t.message}</span>
          <button className="toast-close" onClick={() => onDismiss(t.id)} aria-label="Dismiss">
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
